<template>
  <div>
    <input style="width: 150px;" v-show="ifEditInput_" v-model="inputVal_" v-focus="ifEditInput_" @blur="ifEditInput_ = false" @change="editRowConfirm(inputVal_)" maxlength="20" />
    <div v-show="!ifEditInput_" class="code_shower">
      <span class="code_style" :title="inputVal_">{{ inputVal_ }}</span>
      <i v-if="!disabled" class="el-icon-edit" @click.stop="ifEditInput_ = true" />
    </div>
  </div>
</template>

<script>

export default {
  name: '',
  data () {
    return {
      ifEditInput_: false,
      inputVal_: ''
    }
  },

  props: {
    disabled: { type: Boolean, default: false },
    inputVal: { type: String },
    name: { type: String }
  },

  directives: {
    focus: {
      update (el, { value }) {
        if (value)el.focus()
      }
    }
  },

  mounted () {
    this.initVal(this.inputVal)
  },

  watch: {
    inputVal (val) {
      this.initVal(val)
    }
  },

  methods: {
    initVal (val) {
      this.inputVal_ = val
    },
    editRowConfirm (val) {
      this.$confirm(`确定将${this.name}修改为 "${val}" ?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        closeOnHashChange: false
      }).then(() => {
        this.$emit('editRow', val)
      }).catch(() => {
        this.initVal(this.inputVal)
      })
    }
  }
}
</script>
<style lang='scss' scoped>
.code_shower{
  display: flex;
  align-items: center;
  .code_style{
    padding-right: 10px;
    width: 180px;
    white-space: nowrap;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .el-icon-edit{
    cursor: pointer;
  }
}
</style>
